import { Column, RowData } from '@tanstack/react-table';

import { CheckboxFilter } from '@/components/table/filters/CheckboxFilter';
import { I18N_DE } from '@/i18n/de';
import { AdminLevelType } from '@/modules/api';

type AdminLevelTypeFilterOptionProps = {
  option: AdminLevelType;
};

function AdminLevelTypeFilterOption({ option }: AdminLevelTypeFilterOptionProps) {
  return I18N_DE.AdminLevelType[option];
}

type AdminLevelTypeFilterProps<TData extends RowData, TValue = unknown> = { column?: Column<TData, TValue> };

export function AdminLevelTypeFilter<TData extends RowData, TValue = unknown>({
  column,
}: AdminLevelTypeFilterProps<TData, TValue>) {
  return (
    <CheckboxFilter
      label="Ebene"
      options={Object.values(AdminLevelType)}
      column={column}
      optionLabel={AdminLevelTypeFilterOption}
    />
  );
}
